export default __webpack_public_path__ + "static/media/thumb13_report2@2x.89cb0ee0.png";